module.exports = __webpack_public_path__ + "media/images/seth-doyle-1-6c44ee25e135332ad766f0d4ccdba18d.png";